// The parcel popup's view model, built from GET /api/v1/parcels/lookup.

const formatAcres = acres => acres.toLocaleString('en-US', { maximumFractionDigits: 2 });
const formatUsd = value => `$${Math.round(value).toLocaleString('en-US')}`;

export function parcelPopupModel(body) {
    if (!body) return { kind: 'error' };
    if (!body.covered) return { kind: 'uncovered', state: body.state || null };
    if (!body.parcel) return { kind: 'empty' };

    const parcel = body.parcel;
    const rows = [
        { labelId: 'map.parcelId', value: parcel.parcel_id },
        { labelId: 'map.parcelOwner', value: parcel.owner },
        { labelId: 'map.parcelAddress', value: parcel.address },
        { labelId: 'map.parcelLandUse', value: parcel.land_use },
        {
            labelId: 'map.parcelAcres',
            value: parcel.acres != null ? formatAcres(parcel.acres) : null,
        },
        {
            label: body.value_label,
            value:
                body.value_label && parcel.total_value != null
                    ? formatUsd(parcel.total_value)
                    : null,
        },
    ].filter(row => row.value != null && row.value !== '');

    return { kind: 'parcel', source: body.source, rows };
}

/** Lets a slow response for an earlier click be ignored once a newer click is made. */
export function createLatestRequestGuard() {
    let latest = 0;
    return {
        next: () => {
            latest += 1;
            return latest;
        },
        isCurrent: token => token === latest,
        cancel: () => {
            latest += 1;
        },
    };
}
